import React, { lazy, Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { AnimatePresence } from 'framer-motion';
import { setIsDrawerOpen } from 'store/reducers/navbar-reducer';
import {
  setShowInformationModal,
  showInformationModalSelector,
} from 'store/reducers/resource-voting/resource-voting-reducer';

const ResourceVotingInformationModal = lazy(
  () => import('../ResourceVoting/ResourceVotingInformationModal')
);

export default function ResourceVotingHandler() {
  const dispatch = useDispatch();
  const location = useLocation();
  const showInformationModal = useSelector(showInformationModalSelector);

  useEffect(() => {
    const hash = location.hash;

    if (hash === '#best-of-24-voting-instructions') {
      dispatch(setShowInformationModal(true));
    }
  }, [location]);

  return (
    <AnimatePresence>
      {showInformationModal ? (
        <Suspense fallback={<></>}>
          <ResourceVotingInformationModal />
        </Suspense>
      ) : null}
    </AnimatePresence>
  );
}
